export default __webpack_public_path__ + "static/media/projects_banner.aa09e9f1.png";